const messages = {
  'e.get': 'Failed to get {name}',
  'e.getlist': 'Failed to get {name}',
  'e.valfield': 'Failed to validate the {label}',
  'e.exists': '{value} already exists.',
  'e.notexists': '{value} does not exists.',
};
export default messages;
